/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { persistCombineReducers } from 'redux-persist'
import { routerReducer } from 'react-router-redux'
import { reducer as toastrReducer } from 'react-redux-toastr'

import companyEmployee from 'admin/pages/Company/module'
import user from 'admin/pages/Authentication/module'

import article from 'shared/pages/Article/module'
import catalog from 'shared/pages/Catalog/module'
import breadcrumb from 'shared/components/Breadcrumb/module'
import company from 'shared/pages/Company/module'
import diagnostic from 'shared/pages/Diagnostic/module'
import form from 'user/pages/Form/module'
import formsList from 'user/pages/HomePage/components/FormsList/module'
import murfyBookingForm from 'murfy/pages/MurfyBookingForm/module'
import murfyPages from 'murfy/pages/MurfyPage/module'
import portalComponent from 'user/pages/HomePage/module'
import processOverview from 'user/pages/ProcessOverview/module'
import quickBooking from 'murfy/pages/QuickBooking/module'
import searchBar from 'user/components/SearchBar/module'
import thankYou from 'user/widgets/ThankYouWidget/module'
import tutoriel from 'user/pages/Tutoriel/module'
import stripeCheckout from 'murfy/pages/StripeCheckout/module'
import repairReport from 'murfy/pages/RepairReport/module'
import visitHistory from 'murfy/pages/VisitHistory/module'
/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default function createReducer (persistConfig, asyncReducers) {
  return persistCombineReducers(persistConfig, {
    ...asyncReducers,
    article,
    catalog,
    breadcrumb,
    company,
    companyEmployee,
    diagnostic,
    form,
    formsList,
    murfyBookingForm,
    murfyPages,
    portalComponent,
    processOverview,
    quickBooking,
    repairReport,
    visitHistory,
    routing: routerReducer,
    searchBar,
    stripeCheckout,
    thankYou,
    toastr: toastrReducer,
    tutoriel,
    user
  })
}
